// Vendor
import {useI18n} from 'vue-i18n'

// Components
import HeaderComponent from '../../components/header/index';
import FooterComponent from '../../components/footer/index';
import ImageBoxComponent from '../../components/image-box/index';
import ModalComponent from '../../components/modal/index';
import DataRangeComponent from '../../components/date-range/index';
import ButtonComponent from '../../components/button/index';

export default {
    name: "classifica",
    components: {
        HeaderComponent,
        FooterComponent,
        ImageBoxComponent,
        ModalComponent,
        DataRangeComponent,
        ButtonComponent
    },
    data() {
        return {
            images: [
                {
                    "pid": "59542",
                    "imgPath": '2025/59542.jpg',
                    "selected": false
                },
                {
                    "pid": "92480",
                    "imgPath": '2025/92480.jpg',
                    "selected": false
                },
                {
                    "pid": "92506",
                    "imgPath": '2025/92506.jpg',
                    "selected": false
                },
                {
                    "pid": "162005",
                    "imgPath": '2025/162005.jpg',
                    "selected": false
                },
                {
                    "pid": "162013",
                    "imgPath": '2025/162013.jpg',
                    "selected": false
                },
                {
                    "pid": "162018",
                    "imgPath": '2025/162018.jpg',
                    "selected": false
                },
                {
                    "pid": "162084",
                    "imgPath": '2025/162084.jpg',
                    "selected": false
                },
                {
                    "pid": "162099",
                    "imgPath": '2025/162099.jpg',
                    "selected": false
                },
                {
                    "pid": "162100",
                    "imgPath": '2025/162100.jpg',
                    "selected": false
                },
                {
                    "pid": "162117",
                    "imgPath": '2025/162117.jpg',
                    "selected": false
                },
                {
                    "pid": "163144",
                    "imgPath": '2025/163144.jpg',
                    "selected": false
                },
                {
                    "pid": "170077",
                    "imgPath": '2025/170077.jpg',
                    "selected": false
                },
                {
                    "pid": "170103",
                    "imgPath": '2025/170103.jpg',
                    "selected": false
                },
                {
                    "pid": "464071",
                    "imgPath": '2025/464071.jpg',
                    "selected": false
                },
                {
                    "pid": "464077",
                    "imgPath": '2025/464077.jpg',
                    "selected": false
                },
                {
                    "pid": "746888",
                    "imgPath": '2025/746888.jpg',
                    "selected": false
                },
                {
                    "pid": "746895",
                    "imgPath": '2025/746895.jpg',
                    "selected": false
                },
                {
                    "pid": "746896",
                    "imgPath": '2025/746896.jpg',
                    "selected": false
                },
                {
                    "pid": "747405",
                    "imgPath": '2025/747405.jpg',
                    "selected": false
                },
                {
                    "pid": "751344",
                    "imgPath": '2025/751344.jpg',
                    "selected": false
                }
            ],
            currentPage: 1,
            maxImagesPerPage: 50,
            userLogged: false,
            userPrivacyProfiling: false,
            voted: false,
            pidVoted: '',
            vote_date: '',
            contestActive: false
        }
    },
    setup() {
        const {t} = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return {t}
    },
    computed: {
        /**
         * Filter images by current page and max images per page
         * @returns Array
         */
        paginatedImages() {
            let imagesUnshuffled = this.images;
            const imagesShuffled = imagesUnshuffled
                .map((value) => ({value, sort: Math.random()}))
                .sort((a, b) => a.sort - b.sort)
                .map(({value}) => value)
            return imagesShuffled.slice(0, this.currentPage * this.maxImagesPerPage);
        },

        /**
         * Check if there are another images or not
         * @returns {boolean}
         */
        numberTotal() {
            return (this.currentPage * this.maxImagesPerPage) < this.images.length
        }
    },
    methods: {
        // update page and load more images
        loadMore() {
            this.currentPage += 1;
        }
    }
}